import React, { Component } from 'react'
import { inject, observer } from 'mobx-react'
import DocumentTitle from 'react-document-title'
import PropTypes from 'prop-types'

import Actions from './Actions'
import Paragraph from '@components/Details/Paragraph'
import Row from '@components/Details/Row'

class DetailsTab extends Component {
  static propTypes = {
    parentAccountStore: PropTypes.object,
    sidebarStore: PropTypes.object,
    staticData: PropTypes.object
  }

  render () {
    const { parentAccountStore, sidebarStore, staticData } = this.props
    const {
      parentAccount,
      accountType,
      invoicingCoverage,
      globalInvoicingEntity,
      requiredCode,
      expertsDisclosed
    } = parentAccountStore
    const { HEDGE_FUND } = staticData.CONST.ACCOUNT_TYPES
    return (
      <DocumentTitle
        title={`${parentAccount.parentAccountName} - details | Atheneum Partners`}
      >
        <div className='details-wrapper animate-intro'>
          <Actions
            parentAccount={parentAccount}
            parentAccountStore={parentAccountStore}
            globalInvoicingEntity={globalInvoicingEntity}
          />
          <div className='content'>
            <div className='col-2'>
              <Paragraph
                title='Operational Guidelines'
                value={parentAccount.operationalGuidelines}
              />
              <Paragraph
                title='Disclaimer comment'
                value={parentAccount.disclaimerComment}
              />
            </div>
            <div className='col-2 col-2--padding'>
              <div className='story'>
                <span className='label'>Parent account information</span>
                <div className='group-wrapper'>
                  <div className='group'>
                    <Row label='Account type' text={accountType} />
                    {parentAccount.accountTypeId === HEDGE_FUND && (
                      <Row
                        label='HF compliance required'
                        text={parentAccount.hedgeFundRequired ? 'Yes' : 'No'}
                      />
                    )}
                    <Row label='Invoicing coverage' text={invoicingCoverage} />
                    <Row
                      label='Invoicing entity'
                      text={
                        globalInvoicingEntity && globalInvoicingEntity.legalName
                      }
                      onClick={() =>
                        sidebarStore.openSidebar({
                          id: globalInvoicingEntity.id,
                          template: 'invoicing-entity'
                        })
                      }
                    />
                    <Row label='Case code' text={requiredCode} />
                    <Row
                      label='Show submitted Expert Names on Client Interface'
                      text={expertsDisclosed}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </DocumentTitle>
    )
  }
}

export default inject('sidebarStore')(observer(DetailsTab))
